// Import dependencies
import React, { createElement, useState } from "react";
import { NavLink } from "react-router-dom";

// Import motion library
import { motion } from "framer-motion";

// Import lottie components
import Gear from "../Lotties/Gear";

// Import data content
import { content } from "../assets/data/Content";

// Import components
import Helmet from "../components/Helmet/Helmet";
import SkillsCard from "../components/SkillsCard/SkillsCard";

// Import styles
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Container,
  Row,
} from "reactstrap";
import "../PageStyle/Skills.css";

const Skills = () => {
  // Content
  const { skills } = content;

  // Accordion
  const [open, setOpen] = useState("1");

  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };
  return (
    <>
      <Helmet title="Skills">
        <section className="bg-bg_light_primary h-[100vh]">
          <div className="bg-bg_light_primary h-auto">
            {/* Title & Subtitle */}
            <div className="p-8 m-0">
              <h2 className="title" data-aos="fade-right">
                {skills.title}
              </h2>

              <h4 className="subtitle" data-aos="fade-left">
                {skills.subtitle}
              </h4>
            </div>

            {/* Accordion */}
            <Container className="lg:mt-12">
              <Accordion open={open} toggle={toggle}>
                <Row xs={1} md={2} lg={3}>
                  {/* Frontend Skills */}
                  <AccordionItem>
                    <AccordionHeader targetId="1">
                      <div className="flex items-start gap-4">
                        <div className="text-[30px] text-gray">
                          {createElement(skills.frontendIcon)}
                        </div>

                        <h4 className="text-[16px] md:text-[18px]">
                          Desarrollo Frontend
                        </h4>
                      </div>
                    </AccordionHeader>

                    {/* Skills card */}
                    <AccordionBody accordionId="1">
                      {skills.frontendContent.map((skill, index) => (
                        <motion.div
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                          key={index}
                        >
                          <SkillsCard skill={skill} />
                        </motion.div>
                      ))}
                    </AccordionBody>
                  </AccordionItem>

                  {/* Backend Skills */}
                  <AccordionItem>
                    <AccordionHeader targetId="2">
                      <div className="flex items-start gap-4">
                        <div className="text-[30px] text-gray">
                          {createElement(skills.backendIcon)}
                        </div>

                        <h4 className="text-[16px] md:text-[18px]">
                          Desarrollo Backend
                        </h4>
                      </div>
                    </AccordionHeader>

                    {/* Skills card */}
                    <AccordionBody accordionId="2">
                      {skills.backendContent.map((skill, index) => (
                        <motion.div
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                          key={index}
                        >
                          <SkillsCard skill={skill} />
                        </motion.div>
                      ))}
                    </AccordionBody>
                  </AccordionItem>

                  {/* Development tools */}
                  <AccordionItem>
                    <AccordionHeader targetId="3">
                      <div className="flex items-start gap-4">
                        <div className="text-[30px] text-gray">
                          {createElement(skills.toolsIcon)}
                        </div>

                        <h4 className="text-[16px] md:text-[18px]">
                          Herramientas
                        </h4>
                      </div>
                    </AccordionHeader>

                    {/* Skills card */}
                    <AccordionBody accordionId="3">
                      {skills.toolsContent.map((skill, index) => (
                        <motion.div
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                          key={index}
                        >
                          <SkillsCard skill={skill} />
                        </motion.div>
                      ))}
                    </AccordionBody>
                  </AccordionItem>
                </Row>
              </Accordion>
            </Container>
          </div>
        </section>
        {/* Return */}
        <NavLink
          to={"/home"}
          className="block fixed right-[-2rem] bottom-0 h-[120px] z-[1]"
        >
          <Gear />
        </NavLink>
      </Helmet>
    </>
  );
};

export default Skills;
